import { render, staticRenderFns } from "./InputDetail.vue?vue&type=template&id=531ea512&scoped=true&"
import script from "./InputDetail.vue?vue&type=script&lang=js&"
export * from "./InputDetail.vue?vue&type=script&lang=js&"
import style0 from "./InputDetail.vue?vue&type=style&index=0&id=531ea512&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "531ea512",
  null
  
)

export default component.exports